import { useTranslation } from 'react-i18next';

import ErrorIcon from '@mui/icons-material/ErrorOutline';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import EmptySectionCard from '~/Nova/scenes/Site/components/EmptySectionCard';

import { AiToolingErrorStateProps } from '../utils/types';

/**
 * Error state for the AI Tooling data cards. Mirrors the shared Licenses tab
 * pattern so the whole Self-Managed Hosting section fails the same way.
 */
const AiToolingErrorState = ({ onRetry }: AiToolingErrorStateProps) => {
  const { t } = useTranslation('aiTooling', { keyPrefix: 'error' });

  return (
    <Card data-testid="ai-tooling-error">
      <EmptySectionCard data-testid="ai-tooling-error">
        <ErrorIcon sx={{ fontSize: 40 }} color="error" />
        <Stack spacing={2} alignItems="center" mt={1}>
          <Typography variant="body1">{t('title')}</Typography>
          <Button
            variant="outlined"
            onClick={onRetry}
            data-testid="ai-tooling-retry-btn"
          >
            {t('retry')}
          </Button>
        </Stack>
      </EmptySectionCard>
    </Card>
  );
};

export default AiToolingErrorState;
